import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import './slidein.css';

const Popup = ({isOpen, onClose, onContent, children}) => {
    const dispTime = 2000;

    useEffect(() => {
        let timer;
        if (isOpen) {
            timer = setTimeout(() => {
                onClose();
            }, dispTime);
        }
        
        return () => clearTimeout(timer);
    }, [isOpen, onClose]);

    if(!isOpen) {
        return null;
    }

    return (
        <div className={'slidein ' + (isOpen ? 'open' : '')} onClick={onClose}>
            <div className="slidein_content">
                <span className="slidein_content_close"></span>
                {children}
            </div>
        </div>
    );
};

Popup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default Popup;
